import { projectSymbol, documentSymbol, nodeSymbol, nodeChildrenSymbol, designerSymbol, skeletonSymbol, editorSymbol, settingFieldSymbol, settingTopEntrySymbol, designerCabinSymbol, propSymbol, simulatorHostSymbol, skeletonItemSymbol, editorCabinSymbol, skeletonCabinSymbol, simulatorRenderSymbol } from '@alilc/lowcode-shell';
export default {
  projectSymbol: projectSymbol,
  documentSymbol: documentSymbol,
  nodeSymbol: nodeSymbol,
  nodeChildrenSymbol: nodeChildrenSymbol,
  skeletonSymbol: skeletonSymbol,
  editorSymbol: editorSymbol,
  designerSymbol: designerSymbol,
  settingPropEntrySymbol: settingFieldSymbol,
  settingTopEntrySymbol: settingTopEntrySymbol,
  designerCabinSymbol: designerCabinSymbol,
  editorCabinSymbol: editorCabinSymbol,
  skeletonCabinSymbol: skeletonCabinSymbol,
  propSymbol: propSymbol,
  simulatorHostSymbol: simulatorHostSymbol,
  skeletonItemSymbol: skeletonItemSymbol,
  simulatorRenderSymbol: simulatorRenderSymbol
};